import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserSelectorDropdownComponent } from './presenters/user-selector-dropdown.component';
import { SelectModule } from '../shared/efaact-primeng.module';

@NgModule({
  imports: [
    CommonModule
    , SelectModule
  ],
  exports: [
    UserSelectorDropdownComponent
  ],
  declarations: [
    UserSelectorDropdownComponent,
  ]
})
export class UserSelectorModule { }
